import * as React from "react";
import styled from "styled-components";
import { Label } from "components/bootstrap";
const StyledLabel = styled(Label)`
  margin-left: 5px;
  vertical-align: inherit;
`;
const DefaultLabel = () => /* @__PURE__ */ React.createElement(StyledLabel, { bsStyle: "primary", bsSize: "xsmall" }, "Default");
export default DefaultLabel;
